import { render, staticRenderFns } from "./routerList_desktop.vue?vue&type=template&id=10153cd4&scoped=true&"
import script from "./routerList_desktop.vue?vue&type=script&lang=js&"
export * from "./routerList_desktop.vue?vue&type=script&lang=js&"
import style0 from "./routerList_desktop.vue?vue&type=style&index=0&id=10153cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10153cd4",
  null
  
)

export default component.exports